// Generated on 2026-01-05T16:52:29.017Z
// This file contains preloaded vehicles brands data from the API
// Do not edit manually - use 'npm run generate:vehicles-brands-data' to regenerate

export const preloadedVehiclesBrands: any = [
  {
    "marca": "TOYOTA",
    "busquedas": "137805"
  },
  {
    "marca": "HONDA",
    "busquedas": "133382"
  },
  {
    "marca": "FORD",
    "busquedas": "111097"
  },
  {
    "marca": "HYUNDAI",
    "busquedas": "67823"
  },
  {
    "marca": "NISSAN",
    "busquedas": "60875"
  },
  {
    "marca": "KIA",
    "busquedas": "35214"
  },
  {
    "marca": "MITSUBISHI",
    "busquedas": "31662"
  },
  {
    "marca": "MAZDA",
    "busquedas": "20233"
  },
  {
    "marca": "CHEVROLET",
    "busquedas": "18572"
  },
  {
    "marca": "JEEP",
    "busquedas": "17773"
  },
  {
    "marca": "ISUZU",
    "busquedas": "10308"
  },
  {
    "marca": "PONTIAC",
    "busquedas": "6267"
  },
  {
    "marca": "BMW",
    "busquedas": "4385"
  },
  {
    "marca": "DODGE",
    "busquedas": "3812"
  },
  {
    "marca": "VOLKSWAGEN",
    "busquedas": "2916"
  },
  {
    "marca": "SUZUKI",
    "busquedas": "2804"
  },
  {
    "marca": "SCION",
    "busquedas": "1126"
  },
  {
    "marca": "ACURA",
    "busquedas": "1002"
  },
  {
    "marca": "SUBARU",
    "busquedas": "904"
  },
  {
    "marca": "GMC",
    "busquedas": "865"
  },
  {
    "marca": "MINI",
    "busquedas": "856"
  },
  {
    "marca": "RAM",
    "busquedas": "840"
  },
  {
    "marca": "MERCURY",
    "busquedas": "568"
  },
  {
    "marca": "LEXUS",
    "busquedas": "456"
  },
  {
    "marca": "CHRYSLER",
    "busquedas": "408"
  },
  {
    "marca": "MERCEDES-BENZ",
    "busquedas": "363"
  },
  {
    "marca": "VOLVO",
    "busquedas": "314"
  },
  {
    "marca": "AUDI",
    "busquedas": "228"
  },
  {
    "marca": "INFINITI",
    "busquedas": "216"
  },
  {
    "marca": "SATURN",
    "busquedas": "214"
  },
  {
    "marca": "HUMMER",
    "busquedas": "209"
  },
  {
    "marca": "GEO",
    "busquedas": "145"
  },
  {
    "marca": "CADILLAC",
    "busquedas": "139"
  },
  {
    "marca": "LAND ROVER",
    "busquedas": "126"
  },
  {
    "marca": "LINCOLN",
    "busquedas": "119"
  },
  {
    "marca": "PORSCHE",
    "busquedas": "108"
  },
  {
    "marca": "FIAT",
    "busquedas": "48"
  },
  {
    "marca": "PLYMOUTH",
    "busquedas": "45"
  },
  {
    "marca": "BUICK",
    "busquedas": "37"
  },
  {
    "marca": "RENAULT",
    "busquedas": "32"
  },
  {
    "marca": "JAGUAR",
    "busquedas": "32"
  },
  {
    "marca": "DAIHATSU",
    "busquedas": "32"
  },
  {
    "marca": "DAEWOO",
    "busquedas": "21"
  },
  {
    "marca": "JMC",
    "busquedas": "13"
  },
  {
    "marca": "JAC",
    "busquedas": "7"
  },
  {
    "marca": "MASERATI",
    "busquedas": "6"
  },
  {
    "marca": "JIM",
    "busquedas": "5"
  },
  {
    "marca": "PEUGEOT",
    "busquedas": "5"
  },
  {
    "marca": "MAHINDRA",
    "busquedas": "5"
  },
  {
    "marca": "EAGLE",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "busquedas": "2"
  },
  {
    "marca": "LAMBORGHINI",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "busquedas": "1"
  }
];

export default preloadedVehiclesBrands;
